export default "__VITE_ASSET__C$2cwnq___"